const axios = require('axios');
const logFactory = require('@/libraries/DigiTickets/Logging/logFactory');
const Qs = require('qs'); // This has to be Qs not qs because the dist/qs.js calls it that.

/**
 * A driver to send command to ProPoint Agent to open a cash drawer without printing.
 *
 * @class
 */
class AgentCashDrawerDriver {
    /**
     * @constructor
     */
    constructor() {
        this.axios = axios.create({
            baseURL: 'https://localhost.dtapps.co.uk:44301',
            timeout: 10000,
        });

        this.log = logFactory('AgentCashDrawerDriver');
    }

    /**
     * @param {string} printerName  The printer name from Windows returned by ProPoint Agent
     * @param {string} command      The hex encoded command to send to the printer e.g. 1B 70 00 19 FA
     *
     * @return {Promise<any>}
     */
    openCashDrawer(printerName, command) {
        return this.axios.post(
            '/opencashdrawer',
            Qs.stringify({
                command,
                printerName,
            })
        ).then((result) => {
            this.log.debug('openCashDrawer response', result);
            if (result.data && result.data.success === true) {
                return true;
            }
            throw new Error('Unsuccessful response: ' + JSON.stringify(result.data));
        });
    }
}

module.exports = AgentCashDrawerDriver;
